export const myProfilePath = '/personal/my-account/my-portal/profile';
export const accountLoginPath = '/personal/my-account/login';
export const logoutPath = '/logout';
export const detoxShopPath = '/personal/products-services/mobile/detox-phones';
export const cookiePolicyPath = '/data-protection/cookie-policy';
export const onePassLogoutUrl = `${process.env.GATSBY_ONEPASS_URL}/userLogout.action?portalTy=1`;
